import httpClient from './httpClient';

export const PRODUCT_GROUPS_ENDPOINT = '/backoffice/product-groups';

export const getProductGroupsAPI = (slug) => httpClient.get(`${PRODUCT_GROUPS_ENDPOINT}/${slug}/variants`);
export const putProductGroupsAPI = (slug, params) => httpClient.put(`${PRODUCT_GROUPS_ENDPOINT}/${slug}/variants`, params);

